// The decisions inside three small shortlist dialogues, kept out of their components so they can be
// tested without a DOM: `MultiSelectModal`, `ProfileActionConfirmationModal` and the copy the
// "Email candidate details to me" action shows in the latter.

/**
 * `multi-select-modal.tpl.html`'s hidden `<input type="number" ng-model="ctrl.checkedCandidateIds.length"
 * min="1">` — the form is valid when at least one candidate ends up checked. `ok()` closes only on
 * a valid form; an invalid one stays open with "No candidates were selected".
 */
export function multiSelectHasSelection(checkedCount: number): boolean {
  return checkedCount >= 1
}

/** `sendCandidateDetails`' `inProgressMessage` and `okButtonText`, verbatim. */
export const CANDIDATE_DETAILS_IN_PROGRESS_MESSAGE = 'Preparing candidate details...'
export const PROFILE_ACTION_OK_BUTTON_TEXT = 'Ok'

/** `shortlist.candidate-actions.service.ng1.ts` `sendCandidateDetails` — its two result lines, verbatim. */
export const CANDIDATE_DETAILS_SENT_MESSAGE = 'An email with candidate details is on its way to your inbox.'
export const CANDIDATE_DETAILS_ERROR_MESSAGE =
  'There was an error preparing candidate details, please contact support if problem persists'

/**
 * The `try`/`catch` around `extensionAlertCandidateApi.sendCandidateDetails`: any failure, whatever
 * its cause, is the one support line. Shaped as `ProfileActionConfirmationModal`'s `run`.
 */
export async function candidateDetailsResultMessage(send: () => Promise<unknown>): Promise<string> {
  try {
    await send()
    return CANDIDATE_DETAILS_SENT_MESSAGE
  } catch {
    return CANDIDATE_DETAILS_ERROR_MESSAGE
  }
}
